import { EntityOutputqueue } from "../../entity/EntityOutputqueue";

export class DtoOutputqueuesPostRes extends EntityOutputqueue {}
